import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { motion } from 'framer-motion';
import cn from 'classnames';
import styles from './styles.module.scss';

const ANIMATION_DURATION = 0.3;

const variantsAnimation = {
  hidden: {
    opacity: 0,
    height: 0,
    marginTop: 0,
  },
  visible: {
    opacity: 1,
    height: 'auto',
    marginTop: 0,
  },
};

const FAQItem = ({ item, index, theme = null }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = useCallback(() => {
    setIsOpen((prev) => !prev);
  }, [isOpen]);

  return (
    <div
      className={cn(styles.item, {
        [styles.itemOpen]: isOpen,
        [styles.themeLight]: theme === 'light',
      })}
    >
      <button
        type="button"
        className={styles.itemButton}
        onClick={handleClick}
        aria-expanded={isOpen}
        aria-controls={`faq-answer-${index}`}
      >
        <span className={styles.itemTitle}>{item.question}</span>
        <span className={styles.icon}>
          <span className={styles.iconLine} />
          <span className={cn(styles.iconLine, styles.iconLineVertical)} />
        </span>
      </button>
      <motion.div
        className={styles.answerWrapper}
        initial="hidden"
        animate={isOpen ? 'visible' : 'hidden'}
        variants={variantsAnimation}
        transition={{
          duration: ANIMATION_DURATION,
          ease: [0.4, 0, 0.2, 1],
        }}
      >
        <div
          id={`faq-answer-${index}`}
          className={styles.itemAnswer}
          dangerouslySetInnerHTML={{ __html: item.answer }}
        />
      </motion.div>
    </div>
  );
};

FAQItem.propTypes = {
  item: PropTypes.shape({
    question: PropTypes.string.isRequired,
    answer: PropTypes.string.isRequired,
  }).isRequired,
  index: PropTypes.number.isRequired,
  theme: PropTypes.oneOf(['light']),
};


export default FAQItem;
